import { Copy } from "lucide-react";
import { Button } from "ui-kit-v2/src/button/button";
import { _ } from "i18n";
import styles from "./styles.module.scss";
import { MOBILE_APP_INVITE_LINK } from "common/src/gamePage/constants";

interface CoachReviewsCopyLinkButtonProps {
	lookAs: "link" | "button";
}

const copyProductLink = () => {
	navigator.clipboard.writeText(MOBILE_APP_INVITE_LINK);
};

export const CoachReviewsCopyLinkButton = ({ lookAs }: CoachReviewsCopyLinkButtonProps) => {
	if (lookAs === "link") {
		return (
			<button type="button" onClick={copyProductLink} className={styles["copy-link"]}>
				<Copy size={16} className={styles["copy-link__icon"]} />
				<span className={styles["copy-link__text"]}>{_("game.coachReviews.copyLinkButton.longText")}</span>
			</button>
		);
	}

	return (
		<Button
			type="button"
			size="small"
			onClick={copyProductLink}
			iconLeft={<Copy size={16} />}
			text={_("game.coachReviews.copyLinkButton.shortText")}
			className="w-fit"
		/>
	);
};
